import ReactModal from "react-modal"
import { pauseModalStyle } from '../../assets/Theme.js'
const PauseModal = ({ handleCloseModal, showModal, stopResumeTimer }) => {
    function closeModal() {
        handleCloseModal()
        stopResumeTimer()
    }
    return (
        <div>
            <ReactModal
                style={pauseModalStyle}
                ariaHideApp={false}
                isOpen={showModal}
                contentLabel="Pausar el joc"
                className="game-pause-modal"
            >
                <div className="w-full flex justify-end">
                    <button className="" onClick={closeModal}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 4L20 20" stroke="black" strokeWidth="2"></path>
                            <path d="M4 20L20 4" stroke="black" strokeWidth="2"></path>
                        </svg>
                    </button>
                </div>
                <div className="w-full pt-[20px] grid justify-center">
                    <div className="font-bold text-3xl text-center fontLora">El joc està en pausa</div>
                    <div className="flex justify-center w-full">
                        <button onClick={closeModal} className="my-10 pauseButton">CONTINUAR</button>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
export default PauseModal